module.exports = __webpack_public_path__ + "img/info.18ce6fa9.svg";